module.exports = __webpack_public_path__ + "static/media/gmr_air_hover.30260632.svg";